import axios from "@/plugins/Axios";

const model = "images-tools";

function remove(id) {
  return axios.delete(`${process.env.VUE_APP_API_URL}/${model}/${id}`);
}

export { remove };
